// src/pages/MyCard.jsx
import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { db } from "../firebase";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import {
  FaEye,
  FaEyeSlash,
  FaPalette,
  FaCreditCard,
  FaBox,
} from "react-icons/fa";

const colorOptions = ["#1e3a8a", "#7c3aed", "#059669", "#b91c1c", "#0f172a"];

export default function MyCard() {
  const userId = localStorage.getItem("currentUser");
  const cardRef = doc(db, "users", userId, "card", "info");

  const [card, setCard] = useState(null);
  const [showNumber, setShowNumber] = useState(false);
  const [showNamePrompt, setShowNamePrompt] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const generateCardData = (fullName) => {
    const randomDigits = () =>
      Math.floor(1000 + Math.random() * 9000).toString();
    const cardNumber =
      randomDigits() + randomDigits() + randomDigits() + randomDigits();
    const expiryMonth = String(Math.floor(Math.random() * 12) + 1).padStart(2, "0");
    const expiryYear = String(new Date().getFullYear() + 3).slice(-2);
    const cvc = Math.floor(100 + Math.random() * 900).toString();

    return {
      cardNumber,
      expiry: `${expiryMonth}/${expiryYear}`,
      cvc,
      cardHolder: fullName,
      status: "Processing",
      backgroundColor: "#1e3a8a",
    };
  };

  useEffect(() => {
    const fetchOrCreateCard = async () => {
      const snapshot = await getDoc(cardRef);
      if (snapshot.exists()) {
        setCard(snapshot.data());
      } else {
        setShowNamePrompt(true);
      }
    };

    if (userId) fetchOrCreateCard();
  }, [userId]);

  const handleCreateCard = async () => {
    const fullName = `${firstName.trim()} ${lastName.trim()}`.trim();
    if (!fullName) return;

    const newCard = generateCardData(fullName);
    await setDoc(cardRef, newCard);
    setCard(newCard);
    setShowNamePrompt(false);
  };

  const handleColorChange = async (color) => {
    await updateDoc(cardRef, { backgroundColor: color });
    setCard((prev) => ({ ...prev, backgroundColor: color }));
  };

  const getMaskedCardNumber = (num) => {
    const last4 = num.slice(-4);
    return `**** **** **** ${last4}`;
  };

  const formatFullCardNumber = (num) =>
    num.replace(/(.{4})/g, "$1 ").trim();

  const getMaskedCVC = (cvc) => (showNumber ? cvc : "***");

  return (
    <div className="dashboard-container">
      <Navbar />
      <main
        className="dashboard-main"
        style={{
          maxWidth: "500px",
          margin: "2rem auto",
          padding: "1rem",
        }}
      >
        {showNamePrompt ? (
          <div
            style={{
              background: "#fff",
              borderRadius: "10px",
              padding: "2rem",
              boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
              textAlign: "center",
            }}
          >
            <h2 style={{ marginBottom: "1rem", fontSize: "20px" }}>
              Set up your Card
            </h2>
            <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "1rem" }}>
              Please enter your full name exactly as it appears on your government-issued ID to initialize your card.
            </p>
            <input
              type="text"
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              style={{
                padding: "8px",
                marginBottom: "0.75rem",
                width: "100%",
                borderRadius: "6px",
                border: "1px solid #e5e7eb",
              }}
            />
            <input
              type="text"
              placeholder="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              style={{
                padding: "8px",
                marginBottom: "1rem",
                width: "100%",
                borderRadius: "6px",
                border: "1px solid #e5e7eb",
              }}
            />
            <button
              onClick={handleCreateCard}
              style={{
                backgroundColor: "#1e3a8a",
                color: "#fff",
                padding: "10px 16px",
                borderRadius: "8px",
                fontSize: "14px",
                cursor: "pointer",
                border: "none",
              }}
            >
              Create Card
            </button>
          </div>
        ) : card ? (
          <div
            style={{
              background: "#fff",
              borderRadius: "10px",
              padding: "1rem 1.5rem",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              position: "relative",
            }}
          >
            <h2 style={{ display: "flex", alignItems: "center", fontSize: "20px" }}>
              <FaCreditCard style={{ marginRight: "8px" }} /> My Linked Card
            </h2>
            <p style={{ fontSize: "14px", color: "#6b7280", marginTop: "4px" }}>
              View your card status and details.
            </p>

            <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
              {/* Main Card */}
              <div
                style={{
                  background: card.backgroundColor,
                  color: "white",
                  borderRadius: "8px",
                  padding: "1.5rem",
                  position: "relative",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                  width: "61%",
                }}
              >
                {/* CASHOUT CARD BADGE */}
                <div
                  style={{
                    position: "absolute",
                    top: "12px",
                    right: "12px",
                    color: "rgba(255, 255, 255, 0.9)",
                    fontSize: "14px",
                    fontStyle: "italic",
                    padding: "4px 8px",
                    borderRadius: "9999px",
                    fontWeight: "600",
                  }}
                >
                  CashOut Card
                </div>

                <div
                  style={{
                    width: "40px",
                    height: "30px",
                    backgroundColor: "#d4a42f",
                    borderRadius: "6px",
                  }}
                ></div>

                <div
                  style={{
                    fontSize: "15px",
                    letterSpacing: "3px",
                    marginTop: "2rem",
                    fontFamily: "monospace",
                  }}
                >
                  {showNumber
                    ? formatFullCardNumber(card.cardNumber)
                    : getMaskedCardNumber(card.cardNumber)}
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "1.5rem",
                    fontSize: "12px",
                  }}
                >
                  <div>
                    Card Holder
                    <div style={{ fontSize: "14px", marginTop: "4px" }}>
                      {card.cardHolder}
                    </div>
                  </div>
                  <div>
                    Expires
                    <div style={{ fontSize: "14px", marginTop: "4px" }}>
                      {card.expiry}
                    </div>
                  </div>
                  <div>
                    CVC
                    <div style={{ fontSize: "14px", marginTop: "4px" }}>
                      {getMaskedCVC(card.cvc)}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Color Customization */}
            <div style={{ marginTop: "1rem" }}>
              <div
                style={{
                  fontSize: "14px",
                  color: "#6b7280",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  marginBottom: "0.5rem",
                }}
              >
                <FaPalette />
                Customize card background
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                {colorOptions.map((color) => (
                  <button
                    key={color}
                    onClick={() => handleColorChange(color)}
                    style={{
                      backgroundColor: color,
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      border: "2px solid #e5e7eb",
                      cursor: "pointer",
                    }}
                  ></button>
                ))}
              </div>
            </div>

            {/* Card Status */}
            <hr style={{ margin: "1.5rem 0" }} />
            <div>
              <h4 style={{ fontSize: "14px", marginBottom: "0.5rem" }}>
                Card Status
              </h4>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#e5e7eb",
                  borderRadius: "9999px",
                  padding: "6px 12px",
                  fontSize: "13px",
                  width: "fit-content",
                  marginBottom: "0.5rem",
                }}
              >
                <FaBox style={{ marginRight: "8px" }} />
                Processing
              </div>
              <p style={{ fontSize: "13px", color: "#6b7280" }}>
                Your card is being processed and prepared for shipping.
              </p>
            </div>

            <hr style={{ margin: "1.5rem 0" }} />

            {/* Show Number Toggle */}
            <button
              onClick={() => setShowNumber((prev) => !prev)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "8px 12px",
                backgroundColor: "#f9fafb",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              {showNumber ? <FaEyeSlash /> : <FaEye />}{" "}
              {showNumber ? "Hide Number" : "Show Number"}
            </button>

            <p
              style={{
                marginTop: "1rem",
                fontSize: "12px",
                color: "#6b7280",
              }}
            >
              For security reasons, your full card number and CVC are hidden by default.
              Status updates based on fee payment and estimated shipping times.
            </p>
          </div>
        ) : (
          <p>Loading card...</p>
        )}
      </main>
    </div>
  );
}
